//Componentes generales
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

//Tipos de Estado
import { ifState} from "../../utils/states";

//Estilos
import "./StateChange.css";

// Alertas
import Swal from "sweetalert2";

/* 
    Componente de vista de dialogo de cambio de estado.
    Donde item es el requerimiento a modificar el requerimiento.
    guardarEstado es la función del context que guarda la modificación.
    cerrar es la función encargada de ocultar el dialogo.
*/
function StateChange({ item, guardarEstado, verDetalle, cerrar }) {
  //state del requerimiento.
  const [req, setReq] = useState({ ...item });
  //const [req, setReq] = useState({ ...item, observAut: "" });
  //States para el dropdown
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  //State para estados del requerimiento
  const [opciones, setOpciones] = useState(
    ifState(item.state, item.tDocCodFor)
  );

  const [disabledButton, setDisabledButton] = useState(false);

  const enabled = {
    cursor: "pointer",
  };

  const disabled = {
    cursor: "not-allowed",
    display: "none"
  };

  /* 
        Función encargada de guardar la modificación del requerimiento y lanzar una alerta.
        Donde r es el requerimiento con el nuevo estado.
    */
        const saveReq = async (r) => {
          try {
            setDisabledButton(true);
        
            const resp = await guardarEstado(r, r.state);
        
            if (resp.status && ((resp.status==200))){
              Swal.fire(
                "Nuevo Estado: " + r.state,
                "El Estado fue Modificado Correctamente <br>",
                "success"
              );
            } else {
              Swal.fire({
                icon: "error",
                title: "Estado: " + r.state,
                text: resp.message || "El Estado no fue Enviado. Por favor, vuelve a intentarlo más tarde. ",
              });
            }
            
            setDisabledButton(false);
            cerrar(null);
        
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Error al modificar el estado",
              text: "Hubo un problema al intentar modificar el estado. Intenta nuevamente más tarde.",
            });
            console.error("Error al guardar el estado:", error);
        
            setDisabledButton(false);
            cerrar(null);
          }
        };

  return (
    <div className="container-gr-state">
      <div className="label-state-icon-r">
        <FontAwesomeIcon
          className="state-icon-r"
          icon={faXmark}
          onClick={() => cerrar(null)}
        />
      </div>
      <div className="container-state">
        <div className="label-state-data">
          <strong>{req.tDocCodFor}</strong>&nbsp; - {req.tDocNroFor}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>
            Estado Actual:&nbsp;
          </strong>{" "}
          {item.state}
        </div>
        <div className="container-state-list">
          <Dropdown
            isOpen={dropdownOpen}
            toggle={toggle}
            direction="down"
            className="dropdown-userTypes"
          >
            <DropdownToggle caret>
              {req.state === "" ? "Seleccione un estado" : req.state}
            </DropdownToggle>
            <DropdownMenu>
              {opciones.map(function (itemType, index) {
                return (
                  <article key={itemType}>
                    <DropdownItem
                      onClick={() => setReq({ ...req, state: itemType })}
                    >
                      {itemType}
                    </DropdownItem>
                  </article>
                );
              })}
            </DropdownMenu>
          </Dropdown>
        </div>
        <div className="btn-state-container">
          <button
            className="btn-state"
            style={disabledButton ? disabled : enabled}
            disabled={disabledButton}
            onClick={() => saveReq(req)}
          >
            Cambiar Estado
          </button>
        </div>
      </div>
    </div>
  );
}

export default StateChange;
